
import ChevronRightIcon from '@/fsd/shared/ui/icons/chevronRight';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import {
  INotification,
  topNotificationStore,
} from '../../model/store/NotificationStore';

import WarnIcon from '@fsd/shared/ui/icons/warn.svg';
import { pluralize } from '@fsd/shared/lib/helpers/pluralize/pluralize';

import styles from './TopNotification.module.scss';

interface SingleTopNotificationProps {
  notification: INotification;
}

export const SingleTopNotification = observer(
  ({ notification }: SingleTopNotificationProps) => {
    const count = topNotificationStore.globalAlertsCount;
    const { message, expanded, id } = notification;
    const { toggle, close } = topNotificationStore;

    const isGlobalAlert = notification.key === 'global-alert:validation-summary';
    const hasMultipleErrors = isGlobalAlert && count > 1;
    const isContentVisible = !hasMultipleErrors || expanded;

    return (
      <div className={cx(styles.container, styles[notification.type])}>
        <div className={styles.head}>
          <img
            className={styles.warnIcon}
            src={WarnIcon}
            alt="иконка ошибки"
          />

          <div className={styles.headContent}>
            <h6>
              {
                count === 1 ? 'Обнаружена'
                  :
                  `Обнаружено ${count} `
              }
              {' '}
              {pluralize(count, ['ошибка', 'ошибки', 'ошибок'])}
            </h6>
            <p>Требуется исправление</p>
          </div>

          {!hasMultipleErrors && (
            <div className={styles.singleError}>
              {message}
            </div>
          )}
        </div>

        {hasMultipleErrors && (
          <>
            {isContentVisible && (
              <div className={styles.header}>
                <div className={styles.text}>
                  {message}
                </div>
              </div>
            )}

            <div
              className={styles.overflowWrap}
              onClick={() => toggle(id)}
            >
              <span>{expanded ? 'Скрыть' : 'Подробнее'}</span>

              <button
                type="button"
                className={cx(
                  styles.toggle,
                  expanded && styles.expanded
                )}
              >
                <ChevronRightIcon />
              </button>
            </div>
          </>
        )}

        <button
          type="button"
          className={styles.close}
          onClick={() => close(id)}
        >
          ✕
        </button>
      </div>
    );
  }
);
